import React from 'react';

import { UserPaymentPlanOption } from '../../../generated/graphql';
import { PlanOptionRadio } from './Radio/Radio';

interface PaymentPlanOptionsProps {
  userPlanData: Array<UserPaymentPlanOption>;
  paymentPlanOption: UserPaymentPlanOption | undefined;
  setPaymentPlanOption: (method: UserPaymentPlanOption) => void;
  showCombinedNote?: boolean;
}

const PaymentPlanOptions: React.FC<PaymentPlanOptionsProps> = ({
  userPlanData,
  paymentPlanOption,
  setPaymentPlanOption,
  showCombinedNote
}) => {
  const defaultOption = userPlanData.find((option) => option.isDefault);

  const planRadios = [...userPlanData]
    .sort((a, b) => {
      if (a.paymentPlan === 'Full Pay') return -1;
      if (b.paymentPlan === 'Full Pay') return 1;
      return 0;
    })
    .map((option, i) => {
      if (!defaultOption && option.paymentPlan === 'Full Pay') {
        return (
          <tr key={i}>
            <td>
              <PlanOptionRadio value={option.paymentPlan} defaultChecked />
            </td>
            <td>{option.paymentPlan}</td>
          </tr>
        );
      } else if (defaultOption && option.isDefault) {
        return (
          <tr key={i}>
            <td>
              <PlanOptionRadio value={option.paymentPlan} defaultChecked />
            </td>
            <td>{option.paymentPlan}</td>
          </tr>
        );
      } else {
        return (
          <tr key={i}>
            <td>
              <PlanOptionRadio value={option.paymentPlan} />
            </td>
            <td>{option.paymentPlan}</td>
          </tr>
        );
      }
    });

  const handlePaymentPlanOptionChange = (
    e: React.FormEvent<HTMLDivElement>
  ) => {
    const method: string = (e.target as HTMLInputElement).value;
    const plan = userPlanData.find((item) => {
      return item.paymentPlan === method;
    });
    if (!plan) {
      throw Error(`cannot find corresponding planId for ${method}`);
    }
    setPaymentPlanOption(plan);
  };

  const fullPayPlan = userPlanData.find((item) => {
    return item.paymentPlan === 'Full Pay';
  });

  if (fullPayPlan === undefined) {
    throw Error('cannot find Full Pay plan');
  }

  if (paymentPlanOption === undefined) {
    if (defaultOption) {
      setPaymentPlanOption(defaultOption);
    } else {
      setPaymentPlanOption(fullPayPlan);
    }
  }

  return (
    <div className="PaymentPlanOptions m-2">
      <table className="payment-options">
        <thead>
          <tr>
            <th className="uppercase text-left" colSpan={2}>
              Payment Plan Options
            </th>
          </tr>
        </thead>
        <tbody onChange={handlePaymentPlanOptionChange}>
          {showCombinedNote ? (
            <tr>
              <td colSpan={2}>
                <div className="border border-tertiary bg-white text-lg rounded-md p-3 my-3 max-w">
                  <span className="text-tertiary font-extrabold">Note:</span>{' '}
                  The payment plan selected will be used for both General
                  Liability and Errors &amp; Omissions policies.
                </div>
              </td>
            </tr>
          ) : null}
          {planRadios}
          <tr aria-hidden="true">
            <td colSpan={2} className="py-12" />
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PaymentPlanOptions;
